module.exports = __webpack_public_path__ + "static/img/10005 (3).83604c5.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10005 (3).webp
// module id = cSq8
// module chunks = 14